"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.binaryExpressionNode = void 0;
const common_1 = require("@finley-technologies/common");
const expressions_1 = require("../../expressions");
exports.binaryExpressionNode = {
    hasChildNodes: true,
    getEvaluatorFunction: ({ node, buildContext }) => {
        const binaryExpression = (0, expressions_1.getBinaryExpression)(node.operator);
        // Functions definitions are retrieved from function stack at time of build
        const rightNode = buildContext.functionStack.pop();
        (0, common_1.finleyAssert)(rightNode, 'Unable to generate formula');
        const leftNode = buildContext.functionStack.pop();
        (0, common_1.finleyAssert)(leftNode, 'Unable to generate formula');
        return (evaluatorInput) => {
            // Pre-defined functions are evaluated at runtime on demand when provided with inputs
            const leftNodeEvaluation = leftNode.evaluatorFunction(evaluatorInput);
            const rightNodeEvaluation = rightNode.evaluatorFunction(evaluatorInput);
            const inputs = [leftNodeEvaluation, rightNodeEvaluation];
            const leftNodeOutput = leftNodeEvaluation.output;
            const rightNodeOutput = rightNodeEvaluation.output;
            if (leftNodeOutput.error !== null) {
                return {
                    node,
                    inputs,
                    output: { error: leftNodeOutput.error },
                };
            }
            if (rightNodeOutput.error !== null) {
                return {
                    node,
                    inputs,
                    output: { error: rightNodeOutput.error },
                };
            }
            const output = binaryExpression({
                leftValue: leftNodeOutput.result,
                rightValue: rightNodeOutput.result,
            });
            return {
                node,
                inputs,
                output,
            };
        };
    },
};
//# sourceMappingURL=binaryExpression.js.map